import {
  getCommentBank,
  getMarkingMethodology,
  getSharedItem,
  getShortAnswer,
  getSuccessCriteria,
} from '../../service';

// The bell and older shares spell a comment bank COMMENT_BANKS.
export const sharePreviewType = (type) =>
  type === 'COMMENT_BANKS' ? 'COMMENT_BANK' : type;

// JED-1279: a task loads through its share. GET /assignments/{id} opens only
// for the task's owner and its class members, so a recipient who teaches none
// of those classes got a 404 there.
const loaders = {
  TASK: ({ shareId }) => getSharedItem(shareId),
  COMMENT_BANK: ({ itemId }) => getCommentBank(itemId),
  MARKING_TEMPLATE: ({ itemId }) => getMarkingMethodology(itemId),
  SUCCESS_CRITERIA: ({ itemId }) => getSuccessCriteria(itemId),
  SHORT_ANSWERS: ({ itemId }) => getShortAnswer(itemId),
};

export const hasSharePreview = (type) =>
  Boolean(loaders[sharePreviewType(type)]);

const firstOf = (response) =>
  Array.isArray(response) ? response[0] : response;

// The criteria dialogs map over criterias without a guard.
const withCriterias = (item) =>
  Array.isArray(item.criterias) ? item : { ...item, criterias: [] };

/**
 * What a share's Preview shows. Rejects when there is nothing to show (an
 * error, a 404, an empty response), so the caller shows a load error rather
 * than an empty dialog — of this type or, as JED-1279 did, of another.
 */
export async function loadSharePreview({ shareId, itemId, resourceType }) {
  const type = sharePreviewType(resourceType);
  const load = loaders[type];
  if (!load) throw new Error(`No preview for ${resourceType}`);
  const item = firstOf(await load({ shareId, itemId }));
  if (!item || typeof item !== 'object') throw new Error('Preview unavailable');
  return type === 'SUCCESS_CRITERIA' || type === 'SHORT_ANSWERS'
    ? withCriterias(item)
    : item;
}
